var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 62,
    viewBox: "0 0 487 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    width: 49,
    height: 30,
    rx: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.72 19.084C244.136 19.084 243.608 18.984 243.136 18.784C242.672 18.584 242.304 18.296 242.032 17.92C241.76 17.544 241.62 17.1 241.612 16.588H243.412C243.436 16.932 243.556 17.204 243.772 17.404C243.996 17.604 244.3 17.704 244.684 17.704C245.076 17.704 245.384 17.612 245.608 17.428C245.832 17.236 245.944 16.988 245.944 16.684C245.944 16.436 245.868 16.232 245.716 16.072C245.564 15.912 245.372 15.788 245.14 15.7C244.916 15.604 244.604 15.5 244.204 15.388C243.66 15.228 243.216 15.072 242.872 14.92C242.536 14.76 242.244 14.524 241.996 14.212C241.756 13.892 241.636 13.468 241.636 12.94C241.636 12.444 241.76 12.012 242.008 11.644C242.256 11.276 242.604 10.996 243.052 10.804C243.5 10.604 244.012 10.504 244.588 10.504C245.452 10.504 246.152 10.716 246.688 11.14C247.232 11.556 247.532 12.14 247.588 12.892H245.74C245.724 12.604 245.6 12.368 245.368 12.184C245.144 11.992 244.844 11.896 244.468 11.896C244.14 11.896 243.876 11.98 243.676 12.148C243.484 12.316 243.388 12.56 243.388 12.88C243.388 13.104 243.46 13.292 243.604 13.444C243.756 13.588 243.94 13.708 244.156 13.804C244.38 13.892 244.692 13.996 245.092 14.116C245.636 14.276 246.08 14.436 246.424 14.596C246.768 14.756 247.064 14.996 247.312 15.316C247.56 15.636 247.684 16.056 247.684 16.576C247.684 17.024 247.568 17.44 247.336 17.824C247.104 18.208 246.764 18.516 246.316 18.748C245.868 18.972 245.336 19.084 244.72 19.084ZM248.708 15.676C248.708 14.988 248.849 14.388 249.129 13.876C249.409 13.356 249.797 12.956 250.293 12.676C250.789 12.388 251.357 12.244 251.997 12.244C252.821 12.244 253.501 12.452 254.037 12.868C254.581 13.276 254.945 13.852 255.129 14.596H253.317C253.221 14.308 253.057 14.084 252.825 13.924C252.601 13.756 252.321 13.672 251.985 13.672C251.505 13.672 251.125 13.848 250.845 14.2C250.565 14.544 250.425 15.036 250.425 15.676C250.425 16.308 250.565 16.8 250.845 17.152C251.125 17.496 251.505 17.668 251.985 17.668C252.665 17.668 253.109 17.364 253.317 16.756H255.129C254.945 17.476 254.581 18.048 254.037 18.472C253.493 18.896 252.813 19.108 251.997 19.108C251.357 19.108 250.789 18.968 250.293 18.688C249.797 18.4 249.409 18 249.129 17.488C248.849 16.968 248.708 16.364 248.708 15.676ZM258.039 13.384C258.255 13.032 258.535 12.756 258.879 12.556C259.231 12.356 259.631 12.256 260.079 12.256V14.02H259.635C259.107 14.02 258.707 14.144 258.435 14.392C258.171 14.64 258.039 15.072 258.039 15.688V19H256.359V12.352H258.039V13.384ZM267.391 15.532C267.391 15.772 267.375 15.988 267.343 16.18H262.483C262.523 16.66 262.691 17.036 262.987 17.308C263.283 17.58 263.647 17.716 264.079 17.716C264.703 17.716 265.147 17.448 265.411 16.912H267.223C267.031 17.552 266.663 18.08 266.119 18.496C265.575 18.904 264.907 19.108 264.115 19.108C263.475 19.108 262.899 18.968 262.387 18.688C261.883 18.4 261.487 17.996 261.199 17.476C260.919 16.956 260.779 16.356 260.779 15.676C260.779 14.988 260.919 14.384 261.199 13.864C261.479 13.344 261.871 12.944 262.375 12.664C262.879 12.384 263.459 12.244 264.115 12.244C264.747 12.244 265.311 12.38 265.807 12.652C266.311 12.924 266.699 13.312 266.971 13.816C267.251 14.312 267.391 14.884 267.391 15.532ZM265.651 15.052C265.643 14.62 265.487 14.276 265.183 14.02C264.879 13.756 264.507 13.624 264.067 13.624C263.651 13.624 263.299 13.752 263.011 14.008C262.731 14.256 262.559 14.604 262.495 15.052H265.651ZM277.833 12.352L275.889 19H274.077L272.865 14.356L271.653 19H269.829L267.873 12.352H269.577L270.753 17.416L272.025 12.352H273.801L275.049 17.404L276.225 12.352H277.833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.5 33L266.469 27.75L272.531 27.75L269.5 33Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 45H19.2837H486.42V61.0786H1V45Z",
    fill: "#6A5DFF",
    stroke: "url(#paint0_linear_3286_33835)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7786 61.4595L10.5322 45.1895",
    stroke: "url(#paint1_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6612 61.4595L22.4072 45.1895",
    stroke: "url(#paint2_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5364 61.4595L34.29 45.1895",
    stroke: "url(#paint3_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4193 61.4595L46.1653 45.1895",
    stroke: "url(#paint4_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2949 61.4595L58.0486 45.1895",
    stroke: "url(#paint5_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.17 61.4595L69.9236 45.1895",
    stroke: "url(#paint6_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0523 61.4595L81.7983 45.1895",
    stroke: "url(#paint7_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.928 61.4595L93.6816 45.1895",
    stroke: "url(#paint8_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.81 61.4595L105.556 45.1895",
    stroke: "url(#paint9_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.686 61.4595L117.439 45.1895",
    stroke: "url(#paint10_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.568 61.4595L129.314 45.1895",
    stroke: "url(#paint11_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.444 61.4595L141.198 45.1895",
    stroke: "url(#paint12_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.319 61.4595L153.073 45.1895",
    stroke: "url(#paint13_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.201 61.4595L164.955 45.1895",
    stroke: "url(#paint14_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M180.077 61.4595L176.831 45.1895",
    stroke: "url(#paint15_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M191.96 61.4595L188.706 45.1895",
    stroke: "url(#paint16_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M203.835 61.4595L200.589 45.1895",
    stroke: "url(#paint17_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M215.718 61.4595L212.464 45.1895",
    stroke: "url(#paint18_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M227.593 61.4595L224.347 45.1895",
    stroke: "url(#paint19_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M239.469 61.4595L236.222 45.1895",
    stroke: "url(#paint20_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M251.351 61.4595L248.104 45.1895",
    stroke: "url(#paint21_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M263.227 61.4595L259.98 45.1895",
    stroke: "url(#paint22_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M275.109 61.4595L271.855 45.1895",
    stroke: "url(#paint23_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M286.984 61.4595L283.738 45.1895",
    stroke: "url(#paint24_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M298.867 61.4595L295.613 45.1895",
    stroke: "url(#paint25_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M310.742 61.4595L307.496 45.1895",
    stroke: "url(#paint26_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M322.617 61.4595L319.371 45.1895",
    stroke: "url(#paint27_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M334.501 61.4595L331.255 45.1895",
    stroke: "url(#paint28_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M346.375 61.4595L343.129 45.1895",
    stroke: "url(#paint29_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M358.258 61.4595L355.004 45.1895",
    stroke: "url(#paint30_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M370.133 61.4595L366.887 45.1895",
    stroke: "url(#paint31_linear_3286_33835)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3286_33835",
    x1: 243.335,
    y1: 38.3925,
    x2: 244.085,
    y2: 67.6861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3286_33835",
    x1: 11.941,
    y1: 44.8296,
    x2: 12.3774,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3286_33835",
    x1: 23.816,
    y1: 44.8296,
    x2: 24.2524,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3286_33835",
    x1: 35.6988,
    y1: 44.8296,
    x2: 36.1276,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3286_33835",
    x1: 47.5741,
    y1: 44.8296,
    x2: 48.0105,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3286_33835",
    x1: 59.4497,
    y1: 44.8296,
    x2: 59.8861,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3286_33835",
    x1: 71.3324,
    y1: 44.8296,
    x2: 71.7688,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3286_33835",
    x1: 83.2071,
    y1: 44.8296,
    x2: 83.6435,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3286_33835",
    x1: 95.0904,
    y1: 44.8296,
    x2: 95.5268,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3286_33835",
    x1: 106.965,
    y1: 44.8296,
    x2: 107.402,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3286_33835",
    x1: 118.848,
    y1: 44.8296,
    x2: 119.277,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3286_33835",
    x1: 130.723,
    y1: 44.8296,
    x2: 131.159,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3286_33835",
    x1: 142.599,
    y1: 44.8296,
    x2: 143.035,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3286_33835",
    x1: 154.482,
    y1: 44.8296,
    x2: 154.918,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3286_33835",
    x1: 166.356,
    y1: 44.8296,
    x2: 166.793,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3286_33835",
    x1: 178.239,
    y1: 44.8296,
    x2: 178.676,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3286_33835",
    x1: 190.115,
    y1: 44.8296,
    x2: 190.551,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3286_33835",
    x1: 201.997,
    y1: 44.8296,
    x2: 202.426,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3286_33835",
    x1: 213.873,
    y1: 44.8296,
    x2: 214.309,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3286_33835",
    x1: 225.748,
    y1: 44.8296,
    x2: 226.184,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3286_33835",
    x1: 237.631,
    y1: 44.8296,
    x2: 238.067,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3286_33835",
    x1: 249.506,
    y1: 44.8296,
    x2: 249.942,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3286_33835",
    x1: 261.389,
    y1: 44.8296,
    x2: 261.826,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3286_33835",
    x1: 273.264,
    y1: 44.8296,
    x2: 273.7,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3286_33835",
    x1: 285.147,
    y1: 44.8296,
    x2: 285.575,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3286_33835",
    x1: 297.022,
    y1: 44.8296,
    x2: 297.458,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3286_33835",
    x1: 308.897,
    y1: 44.8296,
    x2: 309.334,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3286_33835",
    x1: 320.78,
    y1: 44.8296,
    x2: 321.216,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3286_33835",
    x1: 332.656,
    y1: 44.8296,
    x2: 333.092,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3286_33835",
    x1: 344.538,
    y1: 44.8296,
    x2: 344.974,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3286_33835",
    x1: 356.413,
    y1: 44.8296,
    x2: 356.85,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3286_33835",
    x1: 368.296,
    y1: 44.8296,
    x2: 368.724,
    y2: 61.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrew);
export default __webpack_public_path__ + "static/media/Screw.a2209d71e1ee7e32ac6700e9f3018e74.svg";
export { ForwardRef as ReactComponent };